






import { Component, Prop, Vue } from 'vue-property-decorator';
import * as def from '@/definitions'

@Component({
    components: {
    },
})

export default class TrimHandleBottomRight extends Vue 
{
    @Prop() private x! : number;
    @Prop() private y! : number;
    @Prop() private width! : number;
    @Prop() private height! : number;
    @Prop() private transform! : string;

    private get points()
    {
        var pts = "";

        var right = this.x + this.width / 2;
        var bottom = this.y + this.height / 2;
        pts += right + "," + bottom + " ";
        pts += right + "," + (bottom - this.height * 3) + " ";
        pts += (right - this.width) + "," + (bottom - this.height * 3) + " ";
        pts += (right - this.width) + "," + (bottom - this.height) + " ";
        pts += (right - this.width * 3) + "," + (bottom - this.height) + " ";
        pts += (right - this.width * 3) + "," + bottom;

        return pts;
    }

    private selectCursor(value)
    {
        this.$emit("selectCursor", value);
    }
}
